
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		customerVisitStatis
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"

	import PickerDate from '@/components/picker-date.vue';
	import PageFooter from '@/components/page-footer.vue';
	import detailDialog from './detail-dialog.vue';

	@Component({
		name: 'CustomerVisitData',
		components: {
			PickerDate,
			PageFooter,
			detailDialog
		}
	})
	export default class CustomerVisitData extends Vue {
		private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png';
		private loading = false;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private isCompany = null;
		private filterTime = '';
		private selectList: any = [{
			value: null,
			label: '全部'
		}, {
			value: true,
			label: '是'
		}, {
			value: false,
			label: '否'
		}];

		private grade = [0,1,2,3]
		private gradelist = [
			{
				label: '客户',
				value: 0
			}, {
				label: '联创',
				value: 1
			}, {
				label: '核心',
				value: 2
			}, {
				label: '总代',
				value: 3
			}
		]
		
		private visible = false;
		private selected:any = {};

		private mounted() {
			this.initTime();
			this.getList()
		}



		private exportList(){
			let url = location.origin + '/pc/member/customerVisitStatisExport'
			url += '?Keywords=' + encodeURIComponent(this.keywords);
			url += '&RoleGrades=' + JSON.stringify(this.grade);
			
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0]
				if (dt[1]){
					url += '&EndTime=' + dt[1]
				}
			}
			window.open(url)
		}
		private initTime(){
			var dt = new Date();
			var year = dt.getFullYear();
			var month:any = dt.getMonth()+1;
			var day:any = dt.getDate();

			month = month > 9 ? month : ('0'+month);
			day = day > 9 ? day : ('0'+day);

			this.filterTime = [year, month, '01'].join('-')+' 00:00:00/'+[year, month, day].join('-')+' 23:59:59';

		}

		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.keywords = '';
			this.grade = [0,1,2,3];
			this.initTime();
			// this.filterTime = '';
			// this.grade = [];

			this.getList();
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords,
				RoleGrades: this.grade
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				if (dt[1]){
					params.EndTime = dt[1];
				}else{
					params.EndTime = '';
				}
			}
			this.loading = true;
			try {
				const res: any = await customerVisitStatis(params);
				this.list = res.Result.Results
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.loading = false;
			}
		}

		private toDetail(e) {
			// console.log(e)
			this.selected = e;
			this.visible = true;
		}
		
		/**
		 * 导出
		 */
		private exportExcel(){
			var url = location.origin + '/pc/profitStatistic/export?';
			url += 'Keywords=' + this.keywords;
			url += '&IsCompany=' + (this.isCompany===null ? '' : this.isCompany);
			
			
			if (this.filterTime && this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + dt[1];
			}
			
			window.open(url)
			
		}
	}
